<template>
  <i class="material-icons" :class="[sizeClass]">
    {{ name }}
  </i>
</template>

<script>
const iconSizes = {
  small: '18',
  default: '24',
  large: '36',
};

export default {
  name: 'ElIcon',
  props: {
    name: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
  },
  computed: {
    sizeClass() {
      if (!this.size) return;
      return `md-${iconSizes[this.size]}`;
    },
  },
};
</script>
